<template>
  <div class="breadcrumbs-container row">
    <!-- Reset button -->
    <div class="power-btn" @click="home" :class="{ active: position == -1 }">
      <span class="mid">
        <p>
          <span>RETURN TO START</span>
        </p>
        <div v-html="SVGGraphics.default.urlIconTwo" class="icon-holder"></div>
      </span>
      <span class="front"></span>
    </div>

    <!-- Breadcrumb Buttons -->
    <ul class="breadcrumbs-list row">
      <transition-group mode="out-in" name="breadcrumb-list">
        <BreadcrumbElement v-for="(name, index) in breadcrumbList" :key="index" :index="index" :position="position" :header="name" :width="elementWidth"
            @breadcrumb-click="breadcrumbClick(index)" v-show="value"/>
      </transition-group>
      <li ref="slider" class="slide-state breadcrumb">
        <span class="back">
          <span class="top-arrow"></span>
          <span class="bottom-arrow"></span>
        </span>
        <span class="mid"></span>
        <span class="front"></span>
      </li>
    </ul>
    <div class="breadcrumbs-container__underlay"></div>
  </div>
</template>

<script>
const SVGGraphics = require('./../svg-graphics');

import BreadcrumbElement from './BreadcrumbElement.vue';

export default {
  components: {
    BreadcrumbElement
  },

  props: {
    breadcrumbList  : Array,
    position        : Number,
    value           : Boolean
  },

  data() {
    return {
      animating     : false,
      startTime     : null,
      startPosition : 0,
      resetClass    : Boolean,
      SVGGraphics
    }
  },

  computed: {
    elements() {
      return this.breadcrumbList.length
    },
    elementWidth() {
      return 100 / this.elements
    }
  },

  methods: {
    home() {
      this.$emit('breadcrumb-home');
    },
    breadcrumbClick(index) {
      this.$emit('breadcrumb-click', index);
    }
  },

  watch: {
    position(newVal, oldVal) {
      this.animating = true;
      this.startTime = +(new Date());

      if (oldVal != this.position) {
        this.startPosition = oldVal;

        // animate slider position
        var animate = () => {
          var dist                          = Math.min((+(new Date()) - this.startTime) / 50, 1);
          var position                      = ((newVal - this.startPosition) * this.elementWidth) * dist;
          var offset                        = (this.startPosition * this.elementWidth + this.elementWidth) + position;
          var zIndex                        = Math.floor((this.elements - 1) - offset/this.elementWidth);

          var calc                          = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 };
          var progress                      = Math.abs(position) / (Math.abs(newVal - this.startPosition) * this.elementWidth);
          var newOffset                     = (this.startPosition * this.elementWidth) + (position * calc(progress));
          this.$refs.slider.style.width     = offset + '%';
          this.$refs.slider.style.zIndex    = zIndex;
          
          if (newOffset.toFixed(3) == (newVal * this.elementWidth).toFixed(3))
            this.animating = false;

          if (this.animating)
            window.requestAnimationFrame(animate);

        };
        animate();
      }
    }
  }
}
</script>

<style lang="scss">
@import '~static/mixins/global';
@import '~static/mixins/variables';


.path{
  fill:#dfdfdf;
  stroke:#dfdfdf;
  stroke-width: 0px;
}
.breadcrumbs-container
{ /*BREADCRUMB CONTAINER*/
  position: fixed;
  width: calc(100% - 60px);
  height: 50px;
  overflow: hidden;
  background: #fcfcfc;
  z-index: 100;
  top: 0;
  margin: 0;


  .row:after {
    display: block;
    margin: 0 auto;
    clear: both;
  }

  /*====
  *
  ** POWER/RESET BUTTON
  *
  ====*/

  .power-btn
  { /*POWER BUTTON*/
    width: 250px;
    left: -170px;
    height: inherit;
    position: absolute;
    z-index: 11;
    cursor: pointer;
    transition: all .3s;

    .icon-holder{
      float: right;
      line-height: 50px;
      margin-right: 20px;

      svg{
        width: 50px;
        margin-top: -3px;
        display: inline-block;
        vertical-align: middle;
      }
    }
    p {
      text-align: right;
      line-height: 48px;
      transition: all .3s;
      font-family: $font-family-interface;
      display: inline-block;
      vertical-align: middle;

      span {
        visibility: hidden;
        opacity: 0;
        display: table-column;
        margin-right: 0px;
      }
    }
    #power_icon{
      width: 65px;
      height: 50px;
      vertical-align: middle;
    }

    &:hover{
      left: 0;
    }
    &:hover,
    &.active{
      .path{
        fill:#fff;
        stroke:#fff;
      }
      p {
        color: #fff;
        span {
          visibility: visible;
          opacity: 1;
          display: inline-block;
        }
      }
      .mid {
        background: #44bda6;
      }
      .front {
        background: #44bda6;
      }
    }

    .mid {
      width: $width-full;
      height: inherit;
      z-index: 10;
      background: #fcfcfc;

      @include transitionBundle(all, .5s);
      @include placementBundle(absolute, 0, initital, initial, 0);
    }
    .front {
      width: 50px;
      height: 50px;
      z-index: 4;
      background: #fcfcfc;
      transform: rotate(45deg);

      @include placementBundle(absolute, 0px, -15px, initial, intitial);
      @include transitionBundle(all, .5s);
      @include borderBundle(1px solid #efefef, 1px solid #efefef, none, none);
    }
  }
  .breadcrumbs-list {
    width: 98%;
    /*width: 91.9%;*/
    height: inherit;
    margin: 0 0 0 60px;
    position: relative;

    span {
      cursor: pointer;
    }
    @for $i from 1 through 6 {
      .step-#{$i} {
        z-index: 6 - $i;
      }
    }
    .breadcrumb
    { /*BREADCRUMB*/
      float: left;
      height: inherit;
      margin: 0;
      position: relative;
      transition: all .3s;
      cursor: inherit;
      z-index: 10;

      span {
        cursor: pointer;
      }
      &.active,
      &.completed {
        .mid {
          background: transparent;
        }
        .breadcrumb-step-name {
          color: $white;
        }
        &:hover{
          .info-icon:hover{
            background-color: $white;

            p{
              color: #242424;
            }
          }
        }
      }

      .front {
        width: 50px;
        height: 50px;
        z-index: 1;
        transform: rotate(45deg);
        opacity: .6;
        background: transparent;

        @include borderBundle(1px solid #969696, 1px solid #969696, none, none);
        @include placementBundle(absolute, 0, -15px, initial, initial);
      }
      &.completed .front {
        @include borderBundle(1px solid #e6e6e6, 1px solid #e6e6e6, none, none);
      }
      .mid {
        height: inherit;
        display: block;
        z-index: 8;
        width: 100%;

        @include placementBundle(absolute, 0, initial, initial, initial);
        @include basicGradient(#ffffff, 0%, #e0e0e0, 100%);
      }
      .breadcrumb-step-name {
        z-index: 10;
        line-height: 48px;
        text-transform: uppercase;
        padding-left: 24px;
        position: relative;
        text-align: $font-center;
        color: #969696;
        white-space: nowrap;
        overflow: hidden;

        @include transitionBundle(all, .6s);
        @include fontStyleBundle($font-family-interface, 14px, bold, none)

        &.completed{
          color: #fff;
          opacity: .6;
        }
      }

      &:hover{
        .info-icon{
          visibility: visible;
          opacity: 1;
        }
        .info-icon:hover {
          background-color: #969696;
        }
      }
    }

    span .breadcrumb:last-child p {
      padding-left: 0px;
    }

    .slide-state
    { /*SLIDE STATE*/
      width: 0;
      left: 0;
      position: absolute;
      transition: all .3s;
      z-index: 4;

      .front {
        background: transparent;
        right: -15px;
        z-index: 10;
        opacity: 1;

        &:after {
          content: '';
          width: 0;
          height: 0;
          transform: rotate(45deg);

          @include borderBundle(26px solid #fcfcfc, none, none, 26px solid transparent);
          @include placementBundle(absolute, 4px, -14px, inherit, inherit)
        }
        &:before {
          content: '';
          width: 0;
          height: 0;
          transform: rotate(-45deg);

          @include borderBundle(26px solid #fcfcfc, none, none, 26px solid transparent);
          @include placementBundle(absolute, -14px, 4px, inherit, inherit);
        }
      }

      .mid {
        padding: 0 25px 0 0;
        box-sizing: content-box;
        background: #00d6c4;
        background: linear-gradient(to right, #00d6c4 0%,#57a8f4 25%,#726dee 50%,#dd69f0 75%,#ff5e9a 100%);
        background-attachment: fixed;
        cursor: pointer;
      }

      .back {
        width: 50px;
        height: inherit;
        z-index: 10;
        background: #fcfcfc;
        transform: rotate(45deg);

        @include borderBundle(1px solid #CCCCCC, 1px solid #CCCCCC, none, none)
        @include placementBundle(absolute, -1px, inherit, inherit, -35px)
      }
    }
  }
}
.breadcrumbs-container__underlay{
  width: 100%;
  height: 50px;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 0;
  box-shadow: 0px 4px 3px -1px rgba(0, 0, 0, .2);
}

</style>



// WEBPACK FOOTER //
// Breadcrumbs.vue?0253c0b8